$(document).ready(function () {
  var $orbitSlider = $(".gor-nbanner-box");

  $orbitSlider.slick({
    adaptiveHeight: true,
    vertical: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,   // time each slide is shown (3 seconds)
    speed: 600,            // transition animation duration (0.6 seconds)
    infinite: true,        // loop back to the first slide
    pauseOnHover: true,    // pause when the mouse is over the slider
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
    ]
  });
});